import { render, staticRenderFns } from "./addcourse.vue?vue&type=template&id=6e613edb&scoped=true&"
import script from "./addcourse.vue?vue&type=script&lang=js&"
export * from "./addcourse.vue?vue&type=script&lang=js&"
import style0 from "./addcourse.vue?vue&type=style&index=0&id=6e613edb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e613edb",
  null
  
)

export default component.exports